/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface CreatePlayer200Response
 */
export interface CreatePlayer200Response {
    /**
     * The player number of the newly created player
     * @type {string}
     * @memberof CreatePlayer200Response
     */
    playerNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlayer200Response
     */
    message?: string;
}


/**
 * Check if a given object implements the CreatePlayer200Response interface.
 */
export function instanceOfCreatePlayer200Response(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function CreatePlayer200ResponseFromJSON(json: any): CreatePlayer200Response {
    return CreatePlayer200ResponseFromJSONTyped(json, false);
}

export function CreatePlayer200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePlayer200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'playerNumber': !exists(json, 'playerNumber') ? undefined : json['playerNumber'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function CreatePlayer200ResponseToJSON(value?: CreatePlayer200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'playerNumber': value.playerNumber,
        'message': value.message,
    };
}

